import React from 'react'
import { NavLink } from 'react-router-dom'
import { UseGlobelcourse } from './allcoursecontaxt/ALLCoursecontaxt';
import Formatprice from './Helper/Formatprice';
import { BASE_URL } from '../Config/Config';
function Listview({allcourse}) {
      const {grid_view} =  UseGlobelcourse();

  console.log(allcourse);
  console.log('list_view');
  return (
       <>
         <div className="tab-content " id="nav-tabContent">
        <div className={ grid_view? "tab-pane fade" : "tab-pane fade active show"} id="tab-grid" role="tabpanel" aria-labelledby="tab-shop-grid">
            <div className="row gy-30 " >
              {
                allcourse.map((curelm , index)=>(
              <div className="col-12 mt-2" key={index}>
                <div className="course-grid">
                  <div className="course-img">
                    <img src={`${BASE_URL}${curelm.CourseMaster_tumbimage}`} alt="img" />
                    <span className="tag"><i className="fas fa-clock" />{curelm.CourseMaster_duration} {curelm.CourseMaster_duration_unit}</span>
                  </div>
                  <div className="course-content">
                    <div className="d-flex justify-content-between">
                      <div className="course-rating">
                        <div className="star-rating" role="img" aria-label="Rated 4.00 out of 5">
                          <span style={{width: '79%'}}>Rated <strong className="rating">4.00</strong> out of 5</span>
                        </div>{curelm.CourseMaster_rating}
                      </div>
                      <div className="offer-tag">{curelm.CourseMaster_fee > 0 ? (<Formatprice price={curelm.CourseMaster_fee} />) : "Free"}
                      </div>
                    </div>
                    <h3 className="course-title text-primary"><NavLink to={`/course-detail/${curelm.slug}#coursetarget`}>{curelm.CourseMaster_title}</NavLink></h3>

<p className="course-text">
  {curelm.course_text
    ? curelm.course_text.replace(/<[^>]+>/g, '').slice(0, 150) + '...'
    : ''}
  <NavLink
    to={`/course-detail/${curelm.slug}`}
    className="th-bt text-primary fw-bold ms-1 link-btn"
  >
    Know More <i className="fa-solid fa-arrow-right ms-2" />
  </NavLink>
</p>

                    {/* <div className="course-meta style2">
                      <span><i className="fal fa-file" />Lesson {curelm.course_lesson}</span>
                      <span><i className="fal fa-user" />Students {curelm.Number_of_students}</span>
                      <span><i className="fal fa-chart-simple" />{curelm.course_level}</span>
                    </div> */}
                    <div className="course-author">
                      {/* <div className="author-info">
                        <img src="assets/img/course/author.png" alt="author" />
                        <NavLink to="/ourinstructer" className="author-name">{curelm.CourseMaster_Courseinstructor.CourseInstructor_name}</NavLink>
                      </div> */}
                      <NavLink to={`/course-detail/${curelm.slug}`}className="link-btn">View Details<i className="fas fa-arrow-right ms-2" /></NavLink> 
                    </div>
                  </div>
                </div>
              </div>
            ))
          
          }
        

            </div>
          </div>
          </div>
    </>
  )
}

export default Listview
